import React, { useState } from "react";

const faqs = [
  {
    question: "What counts as AI Content Generation?",
    answer:
      "Any content created by our AI assistants, such as project plans, tasks, summaries, or reports, counts towards your usage limits. Each generation is a complete document or set of tasks.",
  },
  {
    question: "How does the 14-day free trial work?",
    answer:
      "You get full access to all premium features for 14 days completely free. No payment is needed to start. If you cancel before the trial ends, you pay nothing. Billing only starts after the 14 days if you continue.",
  },
  {
    question: "Can I really cancel anytime during the trial?",
    answer:
      "Absolutely! Cancel anytime during the 14-day trial with a few clicks — no questions asked, no fees, no hidden charges. Your access will continue until the trial ends.",
  },
  {
    question: "Why do you need my payment details for a free trial?",
    answer:
      "We require payment details to ensure a smooth experience if you decide to continue after your trial. Your card is not charged during the trial — only if you decide to stay after 14 days.",
  },
  {
    question: "What happens to my data if I cancel during the trial?",
    answer:
      "Your account and data will be preserved for 30 days after cancellation. This gives you time to reconsider or export your data. You can reactivate your subscription during this time to regain full access.",
  },
];

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className=" py-16 px-4 text-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-extrabold mb-8 text-center">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-slate-800/70 rounded-lg p-4 cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold">{faq.question}</h3>
                <span className="text-2xl">
                  {activeIndex === index ? "−" : "+"}
                </span>
              </div>
              {activeIndex === index && (
                <p className="mt-3 text-gray-200">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}